var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm8":"","md4":""}},[_c('panel',{attrs:{"title":"eTickets"}},[_c('v-form',{attrs:{"slot":"body"},slot:"body"},[_c('h3',[_vm._v("Testing")])]),_vm._v(" "),_c('div',{attrs:{"slot":"actions"},slot:"actions"},[_vm._v("\n        Actions\n      ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-692b76a9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Ticket.vue
// module id = null
// module chunks = 